import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import AddIcon from "@mui/icons-material/Add";
import {
  Autocomplete,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import { Form, Formik, getIn } from "formik";
import * as Yup from "yup";
import { Close } from "@mui/icons-material";
import { useCreateStylesMutation } from "../../Slices/roomNateApis";
import { ErrorAlert, SuccessAlert } from "../../utils/Alerts";
import { LoadingButton } from "@mui/lab";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  height: "90%",
  overflowY: "auto",
  width: { xs: "90%", md: "650px" },
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function BasicModal({styles}) {

  const formRef = React.useRef();
  const [createStyles, resultStats] = useCreateStylesMutation();

  const [open, setOpen] = React.useState(false);
  const [load, setLoad] = React.useState(false);
  const [successAlert, setSuccessAlert] = React.useState(false);
  const [errorAlert, setErrorAlert] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("name is required"),
    description: Yup.string().required("description is required"),
    parentStyle: Yup.mixed().notRequired("parentStyle is not required")
  });

  React.useEffect(() => {
    if (resultStats?.isLoading) {
      setLoad(true);
    }

    if (!resultStats?.isLoading) {
      setLoad(false);
    }

    if (resultStats?.isSuccess) {
      setSuccessAlert(true);
      setTimeout(() => {
        setSuccessAlert(false);
      }, 2000);
      handleClose();
    }

    if (resultStats?.isError) {
      setErrorAlert(true);
      setTimeout(() => {
        setErrorAlert(false);
      }, 2000);
    }
  }, [resultStats]);

  return (
    <>
      {successAlert && (
        <SuccessAlert title="Item has been created successfully!" />
      )}

      {errorAlert && <ErrorAlert title="Something Went Wrong!" />}

      <Button onClick={handleOpen} variant="outlined" endIcon={<AddIcon />}>
        Add Style
      </Button>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box position="fixed" top={10} right={0}>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>
          <Formik
            innerRef={formRef}
            initialValues={{
              name: "",
              description: "",
              parentStyle: styles?.[0]
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              const {
                name, description, parentStyle,
              } = values;

              let id = parentStyle?._id
              createStyles({ name, description, parentStyle: id });
            }}
          >
            {({
              values,
              touched,
              errors,
              handleChange,
              handleBlur,
              isValid,
              setValues,
            }) => (
              <Form noValidate autoComplete="off">
                <Typography
                  id="modal-modal-title"
                  fontWeight={"bold"}
                  fontSize={"20px"}
                  npmsvariants="h6"
                  mb={2}
                >
                  Create a Style
                </Typography>

                <Stack my={2}>
                  <TextField
                    id="outlined-basic"
                    label="Name"
                    variants="outlined"
                    name="name"
                    fullWidth
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                    required
                    helperText={
                      getIn(touched, "name") && getIn(errors, "name")
                        ? getIn(errors, "name")
                        : ""
                    }
                    error={Boolean(
                      getIn(touched, "name") && getIn(errors, "name")
                    )}
                  />
                </Stack>

                <Stack my={2}>
                  <TextField
                    id="outlined-basic"
                    label="Desciption"
                    variants="outlined"
                    name="description"
                    fullWidth
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.description}
                    required
                    helperText={
                      getIn(touched, "description") && getIn(errors, "description")
                        ? getIn(errors, "description")
                        : ""
                    }
                    error={Boolean(
                      getIn(touched, "description") && getIn(errors, "description")
                    )}
                  />
                </Stack>

                {styles?.length >= 1 &&
                  <Autocomplete
                    fullWidth
                    disablePortal
                    onChange={(event, value) =>
                      setValues({
                        ...values,
                        parentStyle: value
                      })
                    }
                    value={styles?.find(
                      (item) =>
                        item._id ===
                        values?.parentStyle
                    )}
                    name={`parentStyle`}
                    id="combo-box-demo"
                    options={styles}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        placeholder={
                          "Select ParentStyle"}
                        name={`parentStyle`}
                        {...params}
                        onBlur={handleBlur}
                        helperText={
                          getIn(touched, "parentStyle") &&
                            getIn(errors, "parentStyle")
                            ? getIn(errors, "parentStyle")
                            : ""
                        }
                        error={Boolean(
                          getIn(touched, "parentStyle") &&
                          getIn(errors, "parentStyle")
                        )}
                      />
                    )}
                  />
                }

                <Stack mt={2}>
                  <LoadingButton
                    loading={load}
                    variant="contained"
                    fullWidth
                    type="submit"
                  >
                    Add
                  </LoadingButton>
                </Stack>
              </Form>
            )}
          </Formik>
        </Box>
      </Modal>
    </>
  );
} 
